var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 53,
    viewBox: "0 0 64 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4251 37.0187L31.6481 26.2417L20.8711 37.0187",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6504 26.2417V50.49",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.256 43.458C56.8838 42.0254 58.9597 39.7585 60.1561 37.015C61.3524 34.2716 61.6011 31.2078 60.8629 28.3074C60.1246 25.4069 58.4415 22.8348 56.0791 20.9972C53.7168 19.1595 50.8097 18.1609 47.8167 18.1589H44.422C43.6065 15.0046 42.0865 12.0762 39.9763 9.59386C37.8661 7.11153 35.2207 5.13987 32.2388 3.82711C29.2569 2.51435 26.0163 1.89466 22.7605 2.01462C19.5046 2.13457 16.3184 2.99106 13.4412 4.51969C10.564 6.04832 8.07081 8.20931 6.14903 10.8402C4.22724 13.4711 2.92688 16.5034 2.3457 19.7092C1.76452 22.915 1.91765 26.2108 2.79358 29.3489C3.6695 32.487 5.24543 35.3856 7.40288 37.827",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4251 37.0187L31.6481 26.2417L20.8711 37.0187",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.e364de08b9f812723c1cf18fcf162b4a.svg";
export { ForwardRef as ReactComponent };